<template>
  <ul class="leftMenu">
    <li
      v-for="item in menuList"
      :key="item.menuKey"
      :class="{ active: actMenuKey === item.menuKey }"
      @click="$fun.routerToPage('/' + item.router)"
    >
      <span>{{ item.label }}</span>
      <i class="el-icon-arrow-right"></i>
    </li>
  </ul>
</template>
<script>
import { faqCategories } from "../unitl/pageData";

export default {
  props: {
    actMenuKey: {
      default: "",
    },
  },
  computed: {
    menuList() {
      return faqCategories.map((item) => ({
        menuKey: item.menuKey,
        router: item.router,
        label: this.$store.state.fanyi ? item.zh_menu : item.it_menu,
      }));
    },
  },
};
</script>
<style lang="scss" scoped="scoped">
@import "@/css/mixin.scss";
.leftMenu {
  padding: 10px;
  width: 215px;
  li {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 14px;
    line-height: 1.5;
    margin-bottom: 20px;
    cursor: pointer;
  }
  li.active {
    color: #009246;
  }
}
</style>
